module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/plan3-1-cd68f71790adfb365da45ec4a75a07c8.webp";